export const WorkoutContent = {
  'exercise-type': {
    'Morning Routine': {
      'mode-time': {
        standart: '10 minúty',
        medium: '12 minúty',
        hard: '14 minúty',
      },
      male: {
        standart: [
          {
            id: 1,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-cat-camel-stretch.json'),
            title: '1. Mačací ťah',
            subtitle: 'x5',
            width: '120px',
            height: '40px',
          },
          {
            id: 2,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-jumping.json'),
            title: '2. Skákanie',
            subtitle: '45 sec',
            width: '120px',
            height: '72px',
          },
          {
            id: 3,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-table-balancing-pose.json'),
            title: '3. Vyvážená stolová pozícia',
            subtitle: 'x20',
            width: '120px',
            height: '30px',
          },
          {
            id: 4,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-leg-squats.json'),
            title: '4. Drep',
            subtitle: 'x12',
            width: '120px',
            height: '80px',
          },
          {
            id: 5,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-push-ups.json'),
            title: '5. Kliky',
            subtitle: 'x10',
            width: '120px',
            height: '50px',
          },
          {
            id: 6,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-bicycle-crunches.json'),
            title: '6. Bicyklové skrútenie',
            subtitle: '30 sec',
            width: '120px',
            height: '35px',
          },
          {
            id: 7,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-lunges.json'),
            title: '7. Výpady',
            subtitle: 'x16',
            width: '120px',
            height: '110px',
          }
        ],
        medium: [
          {
            id: 1,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-cat-camel-stretch.json'),
            title: '1. Mačací ťah',
            subtitle: 'x5',
            width: '120px',
            height: '40px',
          },
          {
            id: 2,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-jumping.json'),
            title: '2. Skákanie',
            subtitle: '1 min',
            width: '120px',
            height: '72px',
          },
          {
            id: 3,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-table-balancing-pose.json'),
            title: '3. Vyvážená stolová pozícia',
            subtitle: 'x24',
            width: '120px',
            height: '30px',
          },
          {
            id: 4,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-leg-squats.json'),
            title: '4. Drep',
            subtitle: 'x15',
            width: '120px',
            height: '80px',
          },
          {
            id: 5,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-push-ups.json'),
            title: '5. Kliky',
            subtitle: 'x15',
            width: '120px',
            height: '50px',
          },
          {
            id: 6,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-bicycle-crunches.json'),
            title: '6. Bicyklové skrútenie',
            subtitle: '45 sec',
            width: '120px',
            height: '35px',
          },
          {
            id: 7,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-lunges.json'),
            title: '7. Výpady',
            subtitle: 'x24',
            width: '120px',
            height: '110px',
          }
        ],
        hard: [
          {
            id: 1,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-cat-camel-stretch.json'),
            title: '1. Mačací ťah',
            subtitle: 'x5',
            width: '120px',
            height: '40px',
          },
          {
            id: 2,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-jumping.json'),
            title: '2. Skákanie',
            subtitle: '75 sec',
            width: '120px',
            height: '72px',
          },
          {
            id: 3,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-table-balancing-pose.json'),
            title: '3. Vyvážená stolová pozícia',
            subtitle: 'x30',
            width: '120px',
            height: '30px',
          },
          {
            id: 4,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-leg-squats.json'),
            title: '4. Drep',
            subtitle: 'x20',
            width: '120px',
            height: '80px',
          },
          {
            id: 5,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-push-ups.json'),
            title: '5. Kliky',
            subtitle: 'x20',
            width: '120px',
            height: '50px',
          },
          {
            id: 6,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-bicycle-crunches.json'),
            title: '6. Bicyklové skrútenie',
            subtitle: '1 min',
            width: '120px',
            height: '35px',
          },
          {
            id: 7,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-lunges.json'),
            title: '7. Výpady',
            subtitle: 'x30',
            width: '120px',
            height: '110px',
          }
        ],
      },
      female: {
        standart: [
          {
            id: 1,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-cat-camel-stretch.json'),
            title: '1. Mačací ťah',
            subtitle: 'x5',
            width: '120px',
            height: '40px',
          },
          {
            id: 2,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-jumping.json'),
            title: '2. Skákanie',
            subtitle: '45 sec',
            width: '120px',
            height: '80px',
          },
          {
            id: 3,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-table-balancing-pose.json'),
            title: '3. Vyvážená stolová pozícia',
            subtitle: 'x20',
            width: '120px',
            height: '40px',
          },
          {
            id: 4,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-leg-squats.json'),
            title: '4. Drep',
            subtitle: 'x12',
            width: '120px',
            height: '70px',
          },
          {
            id: 5,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-push-ups.json'),
            title: '5. Kliky',
            subtitle: 'x10',
            width: '120px',
            height: '40px',
          },
          {
            id: 6,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-bicycle-crunches.json'),
            title: '6. Bicyklové skrútenie',
            subtitle: '30 sec',
            width: '120px',
            height: '40px',
          },
          {
            id: 7,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-lunges.json'),
            title: '7. Výpady',
            subtitle: 'x16',
            width: '120px',
            height: '70px',
          }
        ],
        medium: [
          {
            id: 1,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-cat-camel-stretch.json'),
            title: '1. Mačací ťah',
            subtitle: 'x5',
            width: '120px',
            height: '40px',
          },
          {
            id: 2,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-jumping.json'),
            title: '2. Skákanie',
            subtitle: '1 min',
            width: '120px',
            height: '80px',
          },
          {
            id: 3,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-table-balancing-pose.json'),
            title: '3. Vyvážená stolová pozícia',
            subtitle: 'x24',
            width: '120px',
            height: '40px',
          },
          {
            id: 4,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-leg-squats.json'),
            title: '4. Drep',
            subtitle: 'x15',
            width: '120px',
            height: '70px',
          },
          {
            id: 5,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-push-ups.json'),
            title: '5. Kliky',
            subtitle: 'x15',
            width: '120px',
            height: '40px',
          },
          {
            id: 6,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-bicycle-crunches.json'),
            title: '6. Bicyklové skrútenie',
            subtitle: '45 sec',
            width: '120px',
            height: '40px',
          },
          {
            id: 7,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-lunges.json'),
            title: '7. Výpady',
            subtitle: 'x24',
            width: '120px',
            height: '70px',
          }
        ],
        hard: [
          {
            id: 1,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-cat-camel-stretch.json'),
            title: '1. Mačací ťah',
            subtitle: 'x5',
            width: '120px',
            height: '40px',
          },
          {
            id: 2,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-jumping.json'),
            title: '2. Skákanie',
            subtitle: '75 sec',
            width: '120px',
            height: '80px',
          },
          {
            id: 3,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-table-balancing-pose.json'),
            title: '3. Vyvážená stolová pozícia',
            subtitle: 'x30',
            width: '120px',
            height: '40px',
          },
          {
            id: 4,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-leg-squats.json'),
            title: '4. Drep',
            subtitle: 'x20',
            width: '120px',
            height: '70px',
          },
          {
            id: 5,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-push-ups.json'),
            title: '5. Kliky',
            subtitle: 'x20',
            width: '120px',
            height: '40px',
          },
          {
            id: 6,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-bicycle-crunches.json'),
            title: '6. Bicyklové skrútenie',
            subtitle: '1 min',
            width: '120px',
            height: '40px',
          },
          {
            id: 7,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-lunges.json'),
            title: '7. Výpady',
            subtitle: 'x30',
            width: '120px',
            height: '70px',
          }
        ],
      },
    },
    'Hips, Butt and Thighs': {
      'mode-time': {
        standart: '11 minúty',
        medium: '13 minúty',
        hard: '16 minúty',
      },
      male: {
        standart: [
          {
            id: 1,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-lying-leg-lifts.json'),
            title: '1. Ležiace zdvíhanie nôh',
            subtitle: 'x20',
            width: '120px',
            height: '70px',
          },
          {
            id: 2,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-plank-leg-lift.json'),
            title: '2. Plank s zdvíhaním nôh',
            subtitle: 'x20',
            width: '120px',
            height: '55px',
          },
          {
            id: 3,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-leg-squats.json'),
            title: '3. Drep',
            subtitle: 'x15',
            width: '120px',
            height: '75px',
          },
          {
            id: 4,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-advanced-step-ups.json'),
            title: '4. Pokročilé kroky',
            subtitle: 'x20',
            width: '120px',
            height: '80px',
          },
          {
            id: 5,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-single-leg-hip-thrust.json'),
            title: '5. Jednonožný zdvih bokov',
            subtitle: 'x20',
            width: '120px',
            height: '60px',
          },
          {
            id: 6,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-lunges.json'),
            title: '6. Výpady',
            subtitle: 'x20',
            width: '120px',
            height: '100px',
          },
          {
            id: 7,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-single-leg-squat.json'),
            title: '7. Jednonožný drep',
            subtitle: 'x16',
            width: '120px',
            height: '70px',
          }
        ],
        medium: [
          {
            id: 1,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-lying-leg-lifts.json'),
            title: '1. Ležiace zdvíhanie nôh',
            subtitle: 'x30',
            width: '120px',
            height: '70px',
          },
          {
            id: 2,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-plank-leg-lift.json'),
            title: '2. Plank s zdvíhaním nôh',
            subtitle: 'x30',
            width: '120px',
            height: '55px',
          },
          {
            id: 3,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-leg-squats.json'),
            title: '3. Drep',
            subtitle: 'x20',
            width: '120px',
            height: '75px',
          },
          {
            id: 4,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-advanced-step-ups.json'),
            title: '4. Pokročilé kroky',
            subtitle: 'x24',
            width: '120px',
            height: '80px',
          },
          {
            id: 5,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-single-leg-hip-thrust.json'),
            title: '5. Jednonožný zdvih bokov',
            subtitle: 'x24',
            width: '120px',
            height: '60px',
          },
          {
            id: 6,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-lunges.json'),
            title: '6. Výpady',
            subtitle: 'x24',
            width: '120px',
            height: '100px',
          },
          {
            id: 7,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-single-leg-squat.json'),
            title: '7. Jednonožný drep',
            subtitle: 'x20',
            width: '120px',
            height: '70px',
          }
        ],
        hard: [
          {
            id: 1,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-lying-leg-lifts.json'),
            title: '1. Ležiace zdvíhanie nôh',
            subtitle: 'x40',
            width: '120px',
            height: '70px',
          },
          {
            id: 2,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-plank-leg-lift.json'),
            title: '2. Plank s zdvíhaním nôh',
            subtitle: 'x40',
            width: '120px',
            height: '55px',
          },
          {
            id: 3,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-leg-squats.json'),
            title: '3. Drep',
            subtitle: 'x25',
            width: '120px',
            height: '75px',
          },
          {
            id: 4,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-advanced-step-ups.json'),
            title: '4. Pokročilé kroky',
            subtitle: 'x30',
            width: '120px',
            height: '80px',
          },
          {
            id: 5,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-single-leg-hip-thrust.json'),
            title: '5. Jednonožný zdvih bokov',
            subtitle: 'x30',
            width: '120px',
            height: '60px',
          },
          {
            id: 6,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-lunges.json'),
            title: '6. Výpady',
            subtitle: 'x30',
            width: '120px',
            height: '100px',
          },
          {
            id: 7,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-single-leg-squat.json'),
            title: '7. Jednonožný drep',
            subtitle: 'x24',
            width: '120px',
            height: '70px',
          }
        ],
      },
      female: {
        standart: [
          {
            id: 1,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-lying-leg-lifts.json'),
            title: '1. Ležiace zdvíhanie nôh',
            subtitle: 'x20',
            width: '120px',
            height: '36px',
          },
          {
            id: 2,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-plank-leg-lift.json'),
            title: '2. Plank s zdvíhaním nôh',
            subtitle: 'x20',
            width: '120px',
            height: '50px',
          },
          {
            id: 3,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-leg-squats.json'),
            title: '3. Drep',
            subtitle: 'x15',
            width: '120px',
            height: '75px',
          },
          {
            id: 4,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-advanced-step-ups.json'),
            title: '4. Pokročilé kroky',
            subtitle: 'x20',
            width: '120px',
            height: '78px',
          },
          {
            id: 5,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-single-leg-hip-thrust.json'),
            title: '5. Jednonožný zdvih bokov',
            subtitle: 'x20',
            width: '120px',
            height: '60px',
          },
          {
            id: 6,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-lunges.json'),
            title: '6. Výpady',
            subtitle: 'x20',
            width: '120px',
            height: '70px',
          },
          {
            id: 7,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-single-leg-squat.json'),
            title: '7. Jednonožný drep',
            subtitle: 'x16',
            width: '120px',
            height: '70px',
          }
        ],
        medium: [
          {
            id: 1,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-lying-leg-lifts.json'),
            title: '1. Ležiace zdvíhanie nôh',
            subtitle: 'x30',
            width: '120px',
            height: '36px',
          },
          {
            id: 2,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-plank-leg-lift.json'),
            title: '2. Plank s zdvíhaním nôh',
            subtitle: 'x30',
            width: '120px',
            height: '50px',
          },
          {
            id: 3,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-leg-squats.json'),
            title: '3. Drep',
            subtitle: 'x20',
            width: '120px',
            height: '75px',
          },
          {
            id: 4,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-advanced-step-ups.json'),
            title: '4. Pokročilé kroky',
            subtitle: 'x24',
            width: '120px',
            height: '78px',
          },
          {
            id: 5,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-single-leg-hip-thrust.json'),
            title: '5. Jednonožný zdvih bokov',
            subtitle: 'x24',
            width: '120px',
            height: '60px',
          },
          {
            id: 6,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-lunges.json'),
            title: '6. Výpady',
            subtitle: 'x24',
            width: '120px',
            height: '70px',
          },
          {
            id: 7,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-single-leg-squat.json'),
            title: '7. Jednonožný drep',
            subtitle: 'x20',
            width: '120px',
            height: '70px',
          }
        ],
        hard: [
          {
            id: 1,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-lying-leg-lifts.json'),
            title: '1. Ležiace zdvíhanie nôh',
            subtitle: 'x40',
            width: '120px',
            height: '36px',
          },
          {
            id: 2,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-plank-leg-lift.json'),
            title: '2. Plank s zdvíhaním nôh',
            subtitle: 'x40',
            width: '120px',
            height: '50px',
          },
          {
            id: 3,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-leg-squats.json'),
            title: '3. Drep',
            subtitle: 'x25',
            width: '120px',
            height: '75px',
          },
          {
            id: 4,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-advanced-step-ups.json'),
            title: '4. Pokročilé kroky',
            subtitle: 'x30',
            width: '120px',
            height: '78px',
          },
          {
            id: 5,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-single-leg-hip-thrust.json'),
            title: '5. Jednonožný zdvih bokov',
            subtitle: 'x30',
            width: '120px',
            height: '60px',
          },
          {
            id: 6,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-lunges.json'),
            title: '6. Výpady',
            subtitle: 'x30',
            width: '120px',
            height: '70px',
          },
          {
            id: 7,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-single-leg-squat.json'),
            title: '7. Jednonožný drep',
            subtitle: 'x24',
            width: '120px',
            height: '70px',
          }
        ],
      },
    },
    'Burn Belly Fat': {
      'mode-time': {
        standart: '9 minúty',
        medium: '12 minúty',
        hard: '14 minúty',
      },
      male: {
        standart: [
          {
            id: 1,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-plank.json'),
            title: '1. Plank',
            subtitle: '45 sec',
            width: '120px',
            height: '50px',
          },
          {
            id: 2,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-bicycle-crunches.json'),
            title: '2. Bicyklové skrútenie',
            subtitle: 'x20',
            width: '120px',
            height: '40px',
          },
          {
            id: 3,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-mountain-climber.json'),
            title: '3. Horolezec',
            subtitle: '1 min',
            width: '120px',
            height: '40px',
          },
          {
            id: 4,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-flutter-kicks.json'),
            title: '4. Kopanie',
            subtitle: '1 min',
            width: '120px',
            height: '40px',
          },
          {
            id: 5,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-seated-rotation.json'),
            title: '5. Sedenie s rotáciou',
            subtitle: 'x30',
            width: '120px',
            height: '50px',
          },
          {
            id: 6,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-cocoon.json'),
            title: '6. Kokon',
            subtitle: 'x30',
            width: '120px',
            height: '50px',
          }
        ],
        medium: [
          {
            id: 1,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-plank.json'),
            title: '1. Plank',
            subtitle: '1 min',
            width: '120px',
            height: '50px',
          },
          {
            id: 2,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-bicycle-crunches.json'),
            title: '2. Bicyklové skrútenie',
            subtitle: 'x30',
            width: '120px',
            height: '40px',
          },
          {
            id: 3,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-mountain-climber.json'),
            title: '3. Horolezec',
            subtitle: '90 sec',
            width: '120px',
            height: '40px',
          },
          {
            id: 4,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-flutter-kicks.json'),
            title: '4. Kopanie',
            subtitle: '90 sec',
            width: '120px',
            height: '40px',
          },
          {
            id: 5,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-seated-rotation.json'),
            title: '5. Sedenie s rotáciou',
            subtitle: 'x40',
            width: '120px',
            height: '50px',
          },
          {
            id: 6,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-cocoon.json'),
            title: '6. Kokon',
            subtitle: 'x40',
            width: '120px',
            height: '50px',
          }
        ],
        hard: [
          {
            id: 1,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-plank.json'),
            title: '1. Plank',
            subtitle: '90 sec',
            width: '120px',
            height: '50px',
          },
          {
            id: 2,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-bicycle-crunches.json'),
            title: '2. Bicyklové skrútenie',
            subtitle: 'x40',
            width: '120px',
            height: '40px',
          },
          {
            id: 3,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-mountain-climber.json'),
            title: '3. Horolezec',
            subtitle: '2 min',
            width: '120px',
            height: '40px',
          },
          {
            id: 4,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-flutter-kicks.json'),
            title: '4. Kopanie',
            subtitle: '2 min',
            width: '120px',
            height: '40px',
          },
          {
            id: 5,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-seated-rotation.json'),
            title: '5. Sedenie s rotáciou',
            subtitle: 'x50',
            width: '120px',
            height: '50px',
          },
          {
            id: 6,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-cocoon.json'),
            title: '6. Kokon',
            subtitle: 'x50',
            width: '120px',
            height: '50px',
          }
        ],
      },
      female: {
        standart: [
          {
            id: 1,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-plank.json'),
            title: '1. Plank',
            subtitle: '45 sec',
            width: '120px',
            height: '40px',
          },
          {
            id: 2,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-bicycle-crunches.json'),
            title: '2. Bicyklové skrútenie',
            subtitle: 'x20',
            width: '120px',
            height: '40px',
          },
          {
            id: 3,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-mountain-climber.json'),
            title: '3. Horolezec',
            subtitle: '1 min',
            width: '120px',
            height: '40px',
          },
          {
            id: 4,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-flutter-kicks.json'),
            title: '4. Kopanie',
            subtitle: '1 min',
            width: '120px',
            height: '40px',
          },
          {
            id: 5,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-seated-rotation.json'),
            title: '5. Sedenie s rotáciou',
            subtitle: 'x30',
            width: '120px',
            height: '35px',
          },
          {
            id: 6,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-cocoon.json'),
            title: '6. Kokon',
            subtitle: 'x30',
            width: '120px',
            height: '40px',
          }
        ],
        medium: [
          {
            id: 1,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-plank.json'),
            title: '1. Plank',
            subtitle: '1 min',
            width: '120px',
            height: '40px',
          },
          {
            id: 2,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-bicycle-crunches.json'),
            title: '2. Bicyklové skrútenie',
            subtitle: 'x30',
            width: '120px',
            height: '40px',
          },
          {
            id: 3,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-mountain-climber.json'),
            title: '3. Horolezec',
            subtitle: '90 sec',
            width: '120px',
            height: '40px',
          },
          {
            id: 4,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-flutter-kicks.json'),
            title: '4. Kopanie',
            subtitle: '90 sec',
            width: '120px',
            height: '40px',
          },
          {
            id: 5,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-seated-rotation.json'),
            title: '5. Sedenie s rotáciou',
            subtitle: 'x40',
            width: '120px',
            height: '35px',
          },
          {
            id: 6,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-cocoon.json'),
            title: '6. Kokon',
            subtitle: 'x40',
            width: '120px',
            height: '40px',
          }
        ],
        hard: [
          {
            id: 1,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-plank.json'),
            title: '1. Plank',
            subtitle: '90 sec',
            width: '120px',
            height: '40px',
          },
          {
            id: 2,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-bicycle-crunches.json'),
            title: '2. Bicyklové skrútenie',
            subtitle: 'x40',
            width: '120px',
            height: '40px',
          },
          {
            id: 3,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-mountain-climber.json'),
            title: '3. Horolezec',
            subtitle: '2 min',
            width: '120px',
            height: '40px',
          },
          {
            id: 4,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-flutter-kicks.json'),
            title: '4. Kopanie',
            subtitle: '2 min',
            width: '120px',
            height: '40px',
          },
          {
            id: 5,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-seated-rotation.json'),
            title: '5. Sedenie s rotáciou',
            subtitle: 'x50',
            width: '120px',
            height: '35px',
          },
          {
            id: 6,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-cocoon.json'),
            title: '6. Kokon',
            subtitle: 'x50',
            width: '120px',
            height: '40px',
          }
        ],
      },
    },
    'Full-Body Workout': {
      'mode-time': {
        standart: '15 minúty',
        medium: '18 minúty',
        hard: '22 minúty',
      },
      male: {
        standart: [
          {
            id: 1,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-burpees.json'),
            title: '1. Burpees',
            subtitle: 'x10',
            width: '120px',
            height: '80px',
          },
          {
            id: 2,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-leg-squats.json'),
            title: '2. Drep',
            subtitle: 'x20',
            width: '120px',
            height: '60px',
          },
          {
            id: 3,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-advanced-step-ups.json'),
            title: '3. Pokročilé kroky',
            subtitle: 'x20',
            width: '120px',
            height: '70px',
          },
          {
            id: 4,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-plank.json'),
            title: '4. Plank',
            subtitle: '45 sec',
            width: '120px',
            height: '45px',
          },
          {
            id: 5,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-push-ups.json'),
            title: '5. Kliky',
            subtitle: 'x15',
            width: '120px',
            height: '50px',
          },
          {
            id: 6,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-mountain-climber.json'),
            title: '6. Horolezec',
            subtitle: '1 min',
            width: '120px',
            height: '35px',
          },
          {
            id: 7,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-triceps-dips.json'),
            title: '7. Tricepsové dipy',
            subtitle: 'x30',
            width: '120px',
            height: '60px',
          },
          {
            id: 8,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-incline-push-ups.json'),
            title: '8. Kliky na šikmej ploche',
            subtitle: 'x25',
            width: '120px',
            height: '45px',
          },
          {
            id: 9,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-diagonal-plank.json'),
            title: '9. Diagonálny plank',
            subtitle: 'x20',
            width: '120px',
            height: '45px',
          },
          {
            id: 10,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-jumping.json'),
            title: '10. Skákanie',
            subtitle: '45 sec',
            width: '120px',
            height: '70px',
          },
          {
            id: 11,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-cobra-stretch.json'),
            title: '11. Kobra ťah',
            subtitle: 'x5',
            width: '120px',
            height: '40px',
          }
        ],
        medium: [
          {
            id: 1,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-burpees.json'),
            title: '1. Burpees',
            subtitle: 'x15',
            width: '120px',
            height: '80px',
          },
          {
            id: 2,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-leg-squats.json'),
            title: '2. Drep',
            subtitle: 'x25',
            width: '120px',
            height: '60px',
          },
          {
            id: 3,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-advanced-step-ups.json'),
            title: '3. Pokročilé kroky',
            subtitle: 'x24',
            width: '120px',
            height: '70px',
          },
          {
            id: 4,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-plank.json'),
            title: '4. Plank',
            subtitle: '1 min',
            width: '120px',
            height: '45px',
          },
          {
            id: 5,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-push-ups.json'),
            title: '5. Kliky',
            subtitle: 'x20',
            width: '120px',
            height: '50px',
          },
          {
            id: 6,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-mountain-climber.json'),
            title: '6. Horolezec',
            subtitle: '90 sec',
            width: '120px',
            height: '35px',
          },
          {
            id: 7,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-triceps-dips.json'),
            title: '7. Tricepsové dipy',
            subtitle: 'x40',
            width: '120px',
            height: '60px',
          },
          {
            id: 8,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-incline-push-ups.json'),
            title: '8. Kliky na šikmej ploche',
            subtitle: 'x32',
            width: '120px',
            height: '45px',
          },
          {
            id: 9,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-diagonal-plank.json'),
            title: '9. Diagonálny plank',
            subtitle: 'x30',
            width: '120px',
            height: '45px',
          },
          {
            id: 10,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-jumping.json'),
            title: '10. Skákanie',
            subtitle: '1 min',
            width: '120px',
            height: '70px',
          },
          {
            id: 11,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-cobra-stretch.json'),
            title: '11. Kobra ťah',
            subtitle: 'x5',
            width: '120px',
            height: '40px',
          }
        ],
        hard: [
          {
            id: 1,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-burpees.json'),
            title: '1. Burpees',
            subtitle: 'x20',
            width: '120px',
            height: '80px',
          },
          {
            id: 2,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-leg-squats.json'),
            title: '2. Drep',
            subtitle: 'x30',
            width: '120px',
            height: '60px',
          },
          {
            id: 3,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-advanced-step-ups.json'),
            title: '3. Pokročilé kroky',
            subtitle: 'x30',
            width: '120px',
            height: '70px',
          },
          {
            id: 4,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-plank.json'),
            title: '4. Plank',
            subtitle: '90 sec',
            width: '120px',
            height: '45px',
          },
          {
            id: 5,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-push-ups.json'),
            title: '5. Kliky',
            subtitle: 'x25',
            width: '120px',
            height: '50px',
          },
          {
            id: 6,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-mountain-climber.json'),
            title: '6. Horolezec',
            subtitle: '2 min',
            width: '120px',
            height: '35px',
          },
          {
            id: 7,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-triceps-dips.json'),
            title: '7. Tricepsové dipy',
            subtitle: 'x50',
            width: '120px',
            height: '60px',
          },
          {
            id: 8,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-incline-push-ups.json'),
            title: '8. Kliky na šikmej ploche',
            subtitle: 'x40',
            width: '120px',
            height: '45px',
          },
          {
            id: 9,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-diagonal-plank.json'),
            title: '9. Diagonálny plank',
            subtitle: 'x40',
            width: '120px',
            height: '45px',
          },
          {
            id: 10,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-jumping.json'),
            title: '10. Skákanie',
            subtitle: '75 sec',
            width: '120px',
            height: '70px',
          },
          {
            id: 11,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-cobra-stretch.json'),
            title: '11. Kobra ťah',
            subtitle: 'x5',
            width: '120px',
            height: '40px',
          }
        ],
      },
      female: {
        standart: [
          {
            id: 1,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-burpees.json'),
            title: '1. Burpees',
            subtitle: 'x10',
            width: '120px',
            height: '75px',
          },
          {
            id: 2,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-leg-squats.json'),
            title: '2. Drep',
            subtitle: 'x20',
            width: '120px',
            height: '60px',
          },
          {
            id: 3,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-advanced-step-ups.json'),
            title: '3. Pokročilé kroky',
            subtitle: 'x20',
            width: '120px',
            height: '70px',
          },
          {
            id: 4,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-plank.json'),
            title: '4. Plank',
            subtitle: '45 sec',
            width: '120px',
            height: '30px',
          },
          {
            id: 5,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-push-ups.json'),
            title: '5. Kliky',
            subtitle: 'x15',
            width: '120px',
            height: '30px',
          },
          {
            id: 6,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-mountain-climber.json'),
            title: '6. Horolezec',
            subtitle: '1 min',
            width: '120px',
            height: '35px',
          },
          {
            id: 7,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-triceps-dips.json'),
            title: '7. Tricepsové dipy',
            subtitle: 'x30',
            width: '120px',
            height: '45px',
          },
          {
            id: 8,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-incline-push-ups.json'),
            title: '8. Kliky na šikmej ploche',
            subtitle: 'x25',
            width: '120px',
            height: '40px',
          },
          {
            id: 9,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-diagonal-plank.json'),
            title: '9. Diagonálny plank',
            subtitle: 'x20',
            width: '120px',
            height: '30px',
          },
          {
            id: 10,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-jumping.json'),
            title: '10. Skákanie',
            subtitle: '45 sec',
            width: '120px',
            height: '75px',
          },
          {
            id: 11,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-cobra-stretch.json'),
            title: '11. Kobra ťah',
            subtitle: 'x5',
            width: '120px',
            height: '70px',
          }
        ],
        medium: [
          {
            id: 1,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-burpees.json'),
            title: '1. Burpees',
            subtitle: 'x15',
            width: '120px',
            height: '75px',
          },
          {
            id: 2,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-leg-squats.json'),
            title: '2. Drep',
            subtitle: 'x25',
            width: '120px',
            height: '60px',
          },
          {
            id: 3,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-advanced-step-ups.json'),
            title: '3. Pokročilé kroky',
            subtitle: 'x24',
            width: '120px',
            height: '70px',
          },
          {
            id: 4,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-plank.json'),
            title: '4. Plank',
            subtitle: '1 min',
            width: '120px',
            height: '30px',
          },
          {
            id: 5,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-push-ups.json'),
            title: '5. Kliky',
            subtitle: 'x20',
            width: '120px',
            height: '30px',
          },
          {
            id: 6,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-mountain-climber.json'),
            title: '6. Horolezec',
            subtitle: '90 sec',
            width: '120px',
            height: '35px',
          },
          {
            id: 7,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-triceps-dips.json'),
            title: '7. Tricepsové dipy',
            subtitle: 'x40',
            width: '120px',
            height: '45px',
          },
          {
            id: 8,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-incline-push-ups.json'),
            title: '8. Kliky na šikmej ploche',
            subtitle: 'x32',
            width: '120px',
            height: '40px',
          },
          {
            id: 9,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-diagonal-plank.json'),
            title: '9. Diagonálny plank',
            subtitle: 'x30',
            width: '120px',
            height: '30px',
          },
          {
            id: 10,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-jumping.json'),
            title: '10. Skákanie',
            subtitle: '1 min',
            width: '120px',
            height: '75px',
          },
          {
            id: 11,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-cobra-stretch.json'),
            title: '11. Kobra ťah',
            subtitle: 'x5',
            width: '120px',
            height: '70px',
          }
        ],
        hard: [
          {
            id: 1,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-burpees.json'),
            title: '1. Burpees',
            subtitle: 'x20',
            width: '120px',
            height: '75px',
          },
          {
            id: 2,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-leg-squats.json'),
            title: '2. Drep',
            subtitle: 'x30',
            width: '120px',
            height: '60px',
          },
          {
            id: 3,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-advanced-step-ups.json'),
            title: '3. Pokročilé kroky',
            subtitle: 'x30',
            width: '120px',
            height: '70px',
          },
          {
            id: 4,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-plank.json'),
            title: '4. Plank',
            subtitle: '90 sec',
            width: '120px',
            height: '30px',
          },
          {
            id: 5,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-push-ups.json'),
            title: '5. Kliky',
            subtitle: 'x25',
            width: '120px',
            height: '30px',
          },
          {
            id: 6,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-mountain-climber.json'),
            title: '6. Horolezec',
            subtitle: '2 min',
            width: '120px',
            height: '35px',
          },
          {
            id: 7,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-triceps-dips.json'),
            title: '7. Tricepsové dipy',
            subtitle: 'x50',
            width: '120px',
            height: '45px',
          },
          {
            id: 8,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-incline-push-ups.json'),
            title: '8. Kliky na šikmej ploche',
            subtitle: 'x40',
            width: '120px',
            height: '40px',
          },
          {
            id: 9,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-diagonal-plank.json'),
            title: '9. Diagonálny plank',
            subtitle: 'x40',
            width: '120px',
            height: '30px',
          },
          {
            id: 10,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-jumping.json'),
            title: '10. Skákanie',
            subtitle: '75 sec',
            width: '120px',
            height: '75px',
          },
          {
            id: 11,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-cobra-stretch.json'),
            title: '11. Kobra ťah',
            subtitle: 'x5',
            width: '120px',
            height: '70px',
          }
        ],
      },
    },
    'Toned Arms and Chest': {
      'mode-time': {
        standart: '12 minúty',
        medium: '14 minúty',
        hard: '16 minúty',
      },
      male: {
        standart: [
          {
            id: 1,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-push-ups.json'),
            title: '1. Kliky',
            subtitle: 'x15',
            width: '120px',
            height: '50px',
          },
          {
            id: 2,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-triceps-dips.json'),
            title: '2. Tricepsové dipy',
            subtitle: 'x30',
            width: '120px',
            height: '60px',
          },
          {
            id: 3,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-incline-push-ups.json'),
            title: '3. Kliky na šikmej ploche',
            subtitle: 'x25',
            width: '120px',
            height: '45px',
          },
          {
            id: 4,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-walk-out-push-ups-with-shoulder-taps.json'),
            title: '4. Chôdza s klikmi a dotykmi ramien',
            subtitle: 'x8',
            width: '120px',
            height: '60px',
          },
          {
            id: 5,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-high-to-low-plank.json'),
            title: '5. Plank zhora nadol',
            subtitle: 'x12',
            width: '120px',
            height: '45px',
          },
          {
            id: 6,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-triceps-push-ups.json'),
            title: '6. Tricepsové kliky',
            subtitle: 'x8',
            width: '120px',
            height: '45px',
          },
          {
            id: 7,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-diagonal-plank.json'),
            title: '7. Diagonálny plank',
            subtitle: 'x20',
            width: '120px',
            height: '45px',
          }
        ],
        medium: [
          {
            id: 1,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-push-ups.json'),
            title: '1. Kliky',
            subtitle: 'x20',
            width: '120px',
            height: '50px',
          },
          {
            id: 2,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-triceps-dips.json'),
            title: '2. Tricepsové dipy',
            subtitle: 'x40',
            width: '120px',
            height: '60px',
          },
          {
            id: 3,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-incline-push-ups.json'),
            title: '3. Kliky na šikmej ploche',
            subtitle: 'x32',
            width: '120px',
            height: '45px',
          },
          {
            id: 4,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-walk-out-push-ups-with-shoulder-taps.json'),
            title: '4. Chôdza s klikmi a dotykmi ramien',
            subtitle: 'x10',
            width: '120px',
            height: '60px',
          },
          {
            id: 5,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-high-to-low-plank.json'),
            title: '5. Plank zhora nadol',
            subtitle: 'x15',
            width: '120px',
            height: '45px',
          },
          {
            id: 6,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-triceps-push-ups.json'),
            title: '6. Tricepsové kliky',
            subtitle: 'x12',
            width: '120px',
            height: '45px',
          },
          {
            id: 7,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-diagonal-plank.json'),
            title: '7. Diagonálny plank',
            subtitle: 'x30',
            width: '120px',
            height: '45px',
          }
        ],
        hard: [
          {
            id: 1,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-push-ups.json'),
            title: '1. Kliky',
            subtitle: 'x25',
            width: '120px',
            height: '50px',
          },
          {
            id: 2,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-triceps-dips.json'),
            title: '2. Tricepsové dipy',
            subtitle: 'x50',
            width: '120px',
            height: '60px',
          },
          {
            id: 3,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-incline-push-ups.json'),
            title: '3. Kliky na šikmej ploche',
            subtitle: 'x40',
            width: '120px',
            height: '45px',
          },
          {
            id: 4,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-walk-out-push-ups-with-shoulder-taps.json'),
            title: '4. Chôdza s klikmi a dotykmi ramien',
            subtitle: 'x12',
            width: '120px',
            height: '60px',
          },
          {
            id: 5,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-high-to-low-plank.json'),
            title: '5. Plank zhora nadol',
            subtitle: 'x20',
            width: '120px',
            height: '45px',
          },
          {
            id: 6,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-triceps-push-ups.json'),
            title: '6. Tricepsové kliky',
            subtitle: 'x16',
            width: '120px',
            height: '45px',
          },
          {
            id: 7,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-diagonal-plank.json'),
            title: '7. Diagonálny plank',
            subtitle: 'x40',
            width: '120px',
            height: '45px',
          }
        ],
      },
      female: {
        standart: [
          {
            id: 1,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-push-ups.json'),
            title: '1. Kliky',
            subtitle: 'x15',
            width: '120px',
            height: '35px',
          },
          {
            id: 2,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-triceps-dips.json'),
            title: '2. Tricepsové dipy',
            subtitle: 'x30',
            width: '120px',
            height: '45px',
          },
          {
            id: 3,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-incline-push-ups.json'),
            title: '3. Kliky na šikmej ploche',
            subtitle: 'x25',
            width: '120px',
            height: '45px',
          },
          {
            id: 4,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-walk-out-push-ups-with-shoulder-taps.json'),
            title: '4. Chôdza s klikmi a dotykmi ramien',
            subtitle: 'x8',
            width: '120px',
            height: '60px',
          },
          {
            id: 5,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-high-to-low-plank.json'),
            title: '5. Plank zhora nadol',
            subtitle: 'x12',
            width: '120px',
            height: '35px',
          },
          {
            id: 6,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-triceps-push-ups.json'),
            title: '6. Tricepsové kliky',
            subtitle: 'x8',
            width: '120px',
            height: '35px',
          },
          {
            id: 7,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-diagonal-plank.json'),
            title: '7. Diagonálny plank',
            subtitle: 'x20',
            width: '120px',
            height: '35px',
          }
        ],
        medium: [
          {
            id: 1,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-push-ups.json'),
            title: '1. Kliky',
            subtitle: 'x20',
            width: '120px',
            height: '35px',
          },
          {
            id: 2,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-triceps-dips.json'),
            title: '2. Tricepsové dipy',
            subtitle: 'x40',
            width: '120px',
            height: '45px',
          },
          {
            id: 3,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-incline-push-ups.json'),
            title: '3. Kliky na šikmej ploche',
            subtitle: 'x32',
            width: '120px',
            height: '45px',
          },
          {
            id: 4,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-walk-out-push-ups-with-shoulder-taps.json'),
            title: '4. Chôdza s klikmi a dotykmi ramien',
            subtitle: 'x10',
            width: '120px',
            height: '60px',
          },
          {
            id: 5,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-high-to-low-plank.json'),
            title: '5. Plank zhora nadol',
            subtitle: 'x15',
            width: '120px',
            height: '35px',
          },
          {
            id: 6,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-triceps-push-ups.json'),
            title: '6. Tricepsové kliky',
            subtitle: 'x12',
            width: '120px',
            height: '35px',
          },
          {
            id: 7,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-diagonal-plank.json'),
            title: '7. Diagonálny plank',
            subtitle: 'x30',
            width: '120px',
            height: '35px',
          }
        ],
        hard: [
          {
            id: 1,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-push-ups.json'),
            title: '1. Kliky',
            subtitle: 'x25',
            width: '120px',
            height: '35px',
          },
          {
            id: 2,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-triceps-dips.json'),
            title: '2. Tricepsové dipy',
            subtitle: 'x50',
            width: '120px',
            height: '45px',
          },
          {
            id: 3,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-incline-push-ups.json'),
            title: '3. Kliky na šikmej ploche',
            subtitle: 'x40',
            width: '120px',
            height: '45px',
          },
          {
            id: 4,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-walk-out-push-ups-with-shoulder-taps.json'),
            title: '4. Chôdza s klikmi a dotykmi ramien',
            subtitle: 'x12',
            width: '120px',
            height: '60px',
          },
          {
            id: 5,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-high-to-low-plank.json'),
            title: '5. Plank zhora nadol',
            subtitle: 'x20',
            width: '120px',
            height: '35px',
          },
          {
            id: 6,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-triceps-push-ups.json'),
            title: '6. Tricepsové kliky',
            subtitle: 'x16',
            width: '120px',
            height: '35px',
          },
          {
            id: 7,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-diagonal-plank.json'),
            title: '7. Diagonálny plank',
            subtitle: 'x40',
            width: '120px',
            height: '35px',
          }
        ],
      },
    },
    'Maximum Weight Loss': {
      'mode-time': {
        standart: '12 minúty',
        medium: '16 minúty',
        hard: '22 minúty',
      },
      male: {
        standart: [
          {
            id: 1,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-jumping.json'),
            title: '1. Skákanie',
            subtitle: '1 min',
            width: '120px',
            height: '60px',
          },
          {
            id: 2,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-burpees.json'),
            title: '2. Burpees',
            subtitle: 'x12',
            width: '120px',
            height: '80px',
          },
          {
            id: 3,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-high-intensity-interval-training.json'),
            title: '3. Vysoko-intenzívny intervalový tréning',
            subtitle: '1 min',
            width: '120px',
            height: '40px',
          },
          {
            id: 4,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-lunges.json'),
            title: '4. Výpady',
            subtitle: '1 min',
            width: '120px',
            height: '85px',
          },
          {
            id: 5,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-advanced-step-ups.json'),
            title: '5. Pokročilé kroky',
            subtitle: 'x20',
            width: '120px',
            height: '65px',
          },
          {
            id: 6,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-jump-rope.json'),
            title: '6. Skákanie cez švihadlo',
            subtitle: '1 min',
            width: '120px',
            height: '65px',
          },
          {
            id: 7,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-mountain-climber.json'),
            title: '7. Horolezec',
            subtitle: '1 min',
            width: '120px',
            height: '30px',
          }
        ],
        medium: [
          {
            id: 1,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-jumping.json'),
            title: '1. Skákanie',
            subtitle: '75 sec',
            width: '120px',
            height: '60px',
          },
          {
            id: 2,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-burpees.json'),
            title: '2. Burpees',
            subtitle: 'x16',
            width: '120px',
            height: '80px',
          },
          {
            id: 3,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-high-intensity-interval-training.json'),
            title: '3. Vysoko-intenzívny intervalový tréning',
            subtitle: '90 sec',
            width: '120px',
            height: '40px',
          },
          {
            id: 4,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-lunges.json'),
            title: '4. Výpady',
            subtitle: '75 sec',
            width: '120px',
            height: '85px',
          },
          {
            id: 5,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-advanced-step-ups.json'),
            title: '5. Pokročilé kroky',
            subtitle: 'x24',
            width: '120px',
            height: '65px',
          },
          {
            id: 6,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-jump-rope.json'),
            title: '6. Skákanie cez švihadlo',
            subtitle: '90 sec',
            width: '120px',
            height: '65px',
          },
          {
            id: 7,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-mountain-climber.json'),
            title: '7. Horolezec',
            subtitle: '90 sec',
            width: '120px',
            height: '30px',
          }
        ],
        hard: [
          {
            id: 1,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-jumping.json'),
            title: '1. Skákanie',
            subtitle: '90 sec',
            width: '120px',
            height: '60px',
          },
          {
            id: 2,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-burpees.json'),
            title: '2. Burpees',
            subtitle: 'x22',
            width: '120px',
            height: '80px',
          },
          {
            id: 3,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-high-intensity-interval-training.json'),
            title: '3. Vysoko-intenzívny intervalový tréning',
            subtitle: '2 min',
            width: '120px',
            height: '40px',
          },
          {
            id: 4,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-lunges.json'),
            title: '4. Výpady',
            subtitle: '90 sec',
            width: '120px',
            height: '85px',
          },
          {
            id: 5,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-advanced-step-ups.json'),
            title: '5. Pokročilé kroky',
            subtitle: 'x30',
            width: '120px',
            height: '65px',
          },
          {
            id: 6,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-jump-rope.json'),
            title: '6. Skákanie cez švihadlo',
            subtitle: '2 min',
            width: '120px',
            height: '65px',
          },
          {
            id: 7,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-mountain-climber.json'),
            title: '7. Horolezec',
            subtitle: '2 min',
            width: '120px',
            height: '30px',
          }
        ],
      },
      female: {
        standart: [
          {
            id: 1,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-jumping.json'),
            title: '1. Skákanie',
            subtitle: '1 min',
            width: '120px',
            height: '70px',
          },
          {
            id: 2,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-burpees.json'),
            title: '2. Burpees',
            subtitle: 'x12',
            width: '120px',
            height: '75px',
          },
          {
            id: 3,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-high-intensity-interval-training.json'),
            title: '3. Vysoko-intenzívny intervalový tréning',
            subtitle: '1 min',
            width: '120px',
            height: '30px',
          },
          {
            id: 4,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-lunges.json'),
            title: '4. Výpady',
            subtitle: '1 min',
            width: '120px',
            height: '65px',
          },
          {
            id: 5,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-advanced-step-ups.json'),
            title: '5. Pokročilé kroky',
            subtitle: 'x20',
            width: '120px',
            height: '70px',
          },
          {
            id: 6,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-jump-rope.json'),
            title: '6. Skákanie cez švihadlo',
            subtitle: '1 min',
            width: '120px',
            height: '70px',
          },
          {
            id: 7,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-mountain-climber.json'),
            title: '7. Horolezec',
            subtitle: '1 min',
            width: '120px',
            height: '35px',
          }
        ],
        medium: [
          {
            id: 1,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-jumping.json'),
            title: '1. Skákanie',
            subtitle: '75 sec',
            width: '120px',
            height: '70px',
          },
          {
            id: 2,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-burpees.json'),
            title: '2. Burpees',
            subtitle: 'x16',
            width: '120px',
            height: '75px',
          },
          {
            id: 3,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-high-intensity-interval-training.json'),
            title: '3. Vysoko-intenzívny intervalový tréning',
            subtitle: '90 sec',
            width: '120px',
            height: '30px',
          },
          {
            id: 4,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-lunges.json'),
            title: '4. Výpady',
            subtitle: '75 sec',
            width: '120px',
            height: '65px',
          },
          {
            id: 5,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-advanced-step-ups.json'),
            title: '5. Pokročilé kroky',
            subtitle: 'x24',
            width: '120px',
            height: '70px',
          },
          {
            id: 6,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-jump-rope.json'),
            title: '6. Skákanie cez švihadlo',
            subtitle: '90 sec',
            width: '120px',
            height: '70px',
          },
          {
            id: 7,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-mountain-climber.json'),
            title: '7. Horolezec',
            subtitle: '90 sec',
            width: '120px',
            height: '35px',
          }
        ],
        hard: [
          {
            id: 1,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-jumping.json'),
            title: '1. Skákanie',
            subtitle: '90 sec',
            width: '120px',
            height: '70px',
          },
          {
            id: 2,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-burpees.json'),
            title: '2. Burpees',
            subtitle: 'x22',
            width: '120px',
            height: '75px',
          },
          {
            id: 3,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-high-intensity-interval-training.json'),
            title: '3. Vysoko-intenzívny intervalový tréning',
            subtitle: '2 min',
            width: '120px',
            height: '30px',
          },
          {
            id: 4,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-lunges.json'),
            title: '4. Výpady',
            subtitle: '90 sec',
            width: '120px',
            height: '65px',
          },
          {
            id: 5,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-advanced-step-ups.json'),
            title: '5. Pokročilé kroky',
            subtitle: 'x30',
            width: '120px',
            height: '70px',
          },
          {
            id: 6,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-jump-rope.json'),
            title: '6. Skákanie cez švihadlo',
            subtitle: '2 min',
            width: '120px',
            height: '70px',
          },
          {
            id: 7,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-mountain-climber.json'),
            title: '7. Horolezec',
            subtitle: '2 min',
            width: '120px',
            height: '35px',
          }
        ],
      },
    }
  },
}